import {
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
  select,
} from '@ngrx/store';
import { pipe } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { AllActionsUnion } from '../../../app.actions';
import { UserReservation } from '../../../models/user-reservation/user-reservation';
import { nonNullFilter } from '../../../utils/non-null-filter';
import {
  clearUserReservation,
  storeUserReservation,
} from './user-reservation.actions';

export interface UserReservationState {
  userReservation: UserReservation | null;
}

const initialState: UserReservationState = {
  userReservation: null,
};

export const featureName = 'userReservationFeature';

export function userReservationReducer(
  state_: UserReservationState | undefined,
  action: AllActionsUnion,
): UserReservationState {
  const reducer_ = createReducer<UserReservationState>(
    initialState,
    on(
      storeUserReservation,
      (state, { payload }): UserReservationState => {
        return { ...state, userReservation: payload };
      },
    ),
    on(
      clearUserReservation,
      (state): UserReservationState => {
        return { ...initialState };
      },
    ),
  );
  return reducer_(state_, action);
}

const getFeature = createFeatureSelector<UserReservationState>(featureName);

export const getUserReservation = pipe(
  select(
    createSelector(
      getFeature,
      v => v.userReservation,
    ),
  ),
  distinctUntilChanged(),
);
